<template>
  <v-dialog v-model="dialog" width="800px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("MaterialShowCategory.title")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5" align="center">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="categoryKeyword"
              @text="KeyWord = $event"
              :label="$t('MaterialShowCategory.showCategoryKeyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="5">
          <v-row dense class="pa-1" align="center">
            <span
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("StockMaterials.Fields.usable") }}
            </span>
            <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("CRUD.choosed") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("CRUD.unchoose") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="categoryItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              categories.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{ $t("CRUD.chooseCount", [choosedLength, newChoosedArr.length]) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="saveChoose()">
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import MaterialShowCategories from "@/api/material_show_categories";

export default {
  name: "CategoriesSelectsDialog",

  props: {
    value: Boolean,
    changed: Array,
    categoryIds: Array,
    options: Object,
  },

  components: {
    SearcherKeyword,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("MaterialShowCategory.Fields.show_category_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "name",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    categoryItems() {
      //前端搜索
      return this.categories.filter(
        (item) =>
          ((this.chooseFlgs.length &&
            (item.choose
              ? this.chooseFlgs.find((flg) => flg == item.choose) !=
                  undefined || !item.disabled
              : this.chooseFlgs.find((flg) => flg == item.choose) !=
                undefined)) ||
            !this.chooseFlgs.length) &&
          ((this.categoryKeyword &&
            (item.name.indexOf(this.categoryKeyword) > -1 ||
              item.number.indexOf(this.categoryKeyword) > -1)) ||
            !this.categoryKeyword)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    categories: [],
    categoryKeyword: "",
    chooseFlgs: [0],
    itemsPerPageOptions: 10,
    categoryIdsChoosed: [],
    chooseAll: 0,
    newChoosedArr: [],
    choosedLength: 0,
    fetchTimestamp: 0, //第一次获取商品列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.categoryKeyword = this.KeyWord;
    },
    //获取category列表
    getCategoriesFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.categories = this.categories.map((category) => {
          if (
            this.categoryIdsChoosed.indexOf(category.id) > -1 &&
            (!category.choose || !category.disabled)
          ) {
            category = Object.assign({}, category, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.categoryIdsChoosed.indexOf(category.id) == -1 &&
            (category.choose == 1 || category.disabled)
          ) {
            if (category.choose == 1) {
              category.choose = 0;
            }
            if (category.disabled) {
              category.disabled = false;
            }
          }

          return category;
        });

        return;
      }

      MaterialShowCategories.levelOneList(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.categories = response.data.show_categories.map((category) => {
              //默认勾选
              if (this.categoryIdsChoosed.indexOf(category.id) > -1) {
                category = Object.assign({}, category, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (category.choose == 1 || !category.choose) {
                  category.choose = 0;
                }
                if (category.disabled) {
                  category.disabled = false;
                }
              }

              return category;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },

    saveChoose() {
      this.dialog = false;
      this.$emit("confirm", this.newChoosedArr);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;

          if (this.categoryIds && this.categoryIds.length) {
            this.categoryIdsChoosed = JSON.parse(
              JSON.stringify(this.categoryIds)
            );
          }
          this.choosedLength = this.categoryIdsChoosed.length;
          this.getCategoriesFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.newChoosedArr = [];
          this.categoryKeyword = "";
          this.chooseFlgs = [0];
          this.chooseAll = false;
        }
        this.$emit("input", this.dialog);
      },
    },
    chooseAll: {
      handler() {
        this.categories = this.categories.map(
          function (e) {
            var item = this.categoryItems.find((m) => m.id == e.id);
            if (item) e.choose = this.chooseAll ? 1 : 0;
            return e;
          }.bind(this)
        );
      },
    },
    categories: {
      deep: true,
      handler() {
        //整理新增商品
        this.categories.forEach((category) => {
          if (
            category.choose &&
            !this.categoryIdsChoosed.includes(category.id) &&
            !this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == category.id ||
                new_choosed.category_id == category.id
            )
          ) {
            this.newChoosedArr.push(category);
            this.choosedLength = this.choosedLength + 1;
          } else if (
            !category.choose &&
            this.newChoosedArr.find(
              (new_choosed) =>
                new_choosed.id == category.id ||
                new_choosed.category_id == category.id
            )
          ) {
            this.newChoosedArr.splice(
              this.newChoosedArr.findIndex(
                (new_choosed) =>
                  new_choosed.id == category.id ||
                  new_choosed.category_id == category.id
              ),
              1
            );
            this.choosedLength = this.choosedLength - 1;
          }
        });
      },
    },
  },
};
</script>